<form
  class="advertisement-statistics-form"
  [formGroup]="advertisementFormGroup"
>
  <mat-form-field
    [appIconStatus]="getIconStatus('advertisementLinkStatus')"
    appearance="outline"
    class="advertisement-statistics-form-field"
    [class]="getFieldClasses()"
    [style]="setFieldStyles('advertisementLink')"
    (click)="handleValueClick('advertisementLink')"
  >
    <mat-label>Ссылка на рекламу</mat-label>
    <input
      matInput
      type="text"
      [formControlName]="'advertisementLink'"
      (change)="handleUpdateField('advertisementLink')"
    >
  </mat-form-field>
  <mat-accordion [multi]="true">
    @for (accordion of advertisementStatisticsAccordions; track $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ accordion.label }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="advertisement-statistics-accordion-content">
          @for (field of getAccordionFields(accordion.name); track $index) {
            @switch (field.type) {
              @case ('text') {
                <mat-form-field
                  appearance="outline"
                  class="advertisement-statistics-form-field"
                  [class]="getFieldClasses()"
                  [style]="setFieldStyles(field.fieldName)"
                  (click)="handleValueClick(field.fieldName)"
                >
                  <mat-label>
                    {{ field.label }}
                  </mat-label>
                  <input
                    matInput
                    [type]="field.type"
                    [formControlName]="field.fieldName"
                    (change)="handleUpdateField(field.fieldName)"
                  >
                </mat-form-field>
              }
              @case ('select') {
                <app-custom-mat-select
                  [label]="field.label"
                  [needEmptyValue]="false"
                  [options]="getOptionsByFieldName(field.fieldName)"
                  [selectedValueId]="getSelectedValue(field.fieldName)"
                  [fullWidth]="true"
                  [isEditModeActive]="isEditModeActive()"
                  (selectedChange)="handleSelectedChange($event, field.fieldName)"
                />
              }
              @case ('textarea') {
                <div class="advertisement-statistics-comment">
                  <mat-form-field
                    appearance="outline"
                    class="advertisement-statistics-form-field"
                    [class]="getFieldClasses()"
                  >
                    <mat-label>
                      {{ field.label }}
                    </mat-label>
                    <textarea
                      matInput
                      cdkTextareaAutosize
                      type="text"
                      cdkAutosizeMinRows="4"
                      cdkAutosizeMaxRows="4"
                      [formControlName]="field.fieldName"
                      (change)="handleUpdateField(field.fieldName)"
                    ></textarea>
                  </mat-form-field>
                  <button
                    mat-mini-fab
                    class="advertisement-statistics-fullscreen-text"
                    (click)="handleOpenFullscreenText(field.fieldName)"
                  >
                    <mat-icon class="advertisement-statistics-fullscreen-text-icon">fullscreen</mat-icon>
                  </button>
                </div>
              }
              @case ('button') {
                <button
                  mat-stroked-button
                  class="file-btn"
                  color="primary"
                  (click)="handleOpenHistoryModal()"
                >
                  {{ field.label }}
                </button>
              }
            }
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</form>
